export default "__VITE_ASSET__C0ltzsz7__"